import { Component, OnInit, ViewChild, Output, EventEmitter, TemplateRef } from '@angular/core';

import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { ToastrService } from 'ngx-toastr';
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmComponent } from '../../confirm/confirm';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { Router, ActivatedRoute } from '@angular/router';
import { QuotationService } from 'src/app/_services/Quotation/quotation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
;

@Component({
  selector: 'app-allquotation',
  templateUrl: './allquotation.component.html',
  styleUrls: ['./allquotation.component.css'],
  providers:[Dateconfig,CustomLoaderCComponent,ToastrService]

})
export class AllquotationComponent implements OnInit {  
  public breadcrumb: any;
  options = {
    close: false,
    expand: true,
    minimize: true,
    reload: false
  };
  columns: any = [];
  rows: any;
  name = 'Angular';
  model:any={};
  value: any;
  loadingIndicator: true;
  selected = [];
  temp = [];
  temp2 = [];
  confirmResult=null;
    
  @ViewChild('ng-select') ngSelect;
  @BlockUI('singleSelect') blockUISingleSelect: NgBlockUI;
  @BlockUI('multipleSelect') blockUIMultipleSelect: NgBlockUI;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @ViewChild(DatatableComponent) table: DatatableComponent;
 // @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
/**
   *
   * @param NgbModal      modal
   */
  
  constructor(
    private spinner: CustomLoaderCComponent,
    private dateconfig:Dateconfig,
    private modalpop: NgbModal,
    private toastrService:ToastrService,
    private router: ActivatedRoute,
    private routernav: Router,
    private QuotationService: QuotationService,
    private SimpleModalService:SimpleModalService) { }
    
    

    UserTypeDescription
    ngOnInit() {
      this.UserTypeDescription= localStorage.getItem(LocalStorageConstants.USER_TYPE_DESCRIPTION);
    this.breadcrumb = {
      'mainlabel': 'All Quotation',
      'links': [
        {
          'name': 'Customers',
          'isLink': true,
          'link': '/customer/customers'
        },
      ]
    };
    this.spinner.showSpinner();
    this.QuotationService.getall().subscribe(Response => {
      this.rows = Response;
       this.temp2 = Response;
       this.temp = Response;
       this.spinner.hideSpinner();
     
       
      });


  }
  updateFilter(event) {
    
    const val = event.target.value.toLowerCase();
    this.rows = [...this.temp2]; // and here you have to initialize it with your data
    this.temp = [...this.rows];
    // filter our data
    const temp = this.rows.filter(function (d) {
      return d.customerFullName.toLowerCase().indexOf(val) !== -1 ||
     
      d.quotationType.toLowerCase().indexOf(val) !== -1 ||
      ("qu_"+ (d.quotationNo.toString().toLowerCase())).indexOf(val) !== -1 ||
      ("qu_ "+ (d.quotationNo.toString().toLowerCase())).indexOf(val) !== -1 ||
      d.quotationEnquiryContact.toLowerCase().indexOf(val) !== -1 ||
   
      !val;
    });
    this.rows = temp;
  }
  showConfirm(id) {
    this.SimpleModalService.addModal(ConfirmComponent, {
      title: 'Confirmation',
      message: 'Are you sure to delete this record ?'})
      .subscribe((isConfirmed) => {
        // Get modal result
        this.confirmResult = isConfirmed;
        if(isConfirmed){
        
        this.spinner.showSpinner();
          
          this.QuotationService.delete(id).subscribe(
            (res: any) => {
             
              if(res.result==1){
             this.spinner.hideSpinner();
                this.ngOnInit();
              this.toastrService.success(res.userMessage ,'', { timeOut: 1000, closeButton: true });
              }
              else{
                  this.spinner.hideSpinner();
                  this.toastrService.error(res.userMessage ,'', { timeOut: 3000, closeButton: true });
                 }
              },
            err => {
              this.spinner.hideSpinner();
              this.toastrService.error('server is down','', { timeOut: 3000, closeButton: true });
            }
          )
      
         
        }
    });
  }
  encrypt(id){
    return btoa(id);
  }
  // onFooterPage(event: any) {
  //   event.page - 1;
  //   // this.bodyComponent.updateOffsetY(this.offset);

  //   // this.page.emit({
  //   //   count: this.count,
  //   //   pageSize: this.pageSize,
  //   //   limit: this.limit,
  //   //   offset: this.offset
  //   // });
  // }
}
